// extracted by mini-css-extract-plugin
export default {"historicalContainer":"style_historicalContainer__BmQ3Y","infoBadge":"style_infoBadge__nhM+h","historicIcon":"style_historicIcon__V5YZx"};